"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const color_1 = require("../utils/color");
const primary = "#6a257b";
const secondary = "#63bedd";
const tertiary = "#00a687";
const background = "#ffffff";
const lightScheme = {
    colorScheme: "light",
    primary,
    lightprimary: (0, color_1.tint)(primary, 0.9),
    lighterprimary: (0, color_1.tint)(primary, 0.96),
    secondary,
    lightsecondary: (0, color_1.tint)(secondary, 0.8),
    lightersecondary: (0, color_1.tint)(secondary, 0.86),
    tertiary,
    lighttertiary: (0, color_1.tint)(tertiary, 0.8),
    lightertertiary: (0, color_1.tint)(tertiary, 0.86),
    text: "#1b1b1b",
    background,
    darkgray: "#7b7b7e",
    gray: "#aaafb1",
    lightgray: "#cfd4d7",
    lightergray: "#f3f5f6",
    almostwhite: "#fafbff",
    success: "#00bc60",
    warning: "#ffd53d",
    error: "#bc3d00",
};
exports.default = lightScheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlnaHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi90aGVtaW5nL3NjaGVtZXMvbGlnaHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwwQ0FBc0M7QUFFdEMsTUFBTSxPQUFPLEdBQUcsU0FBUyxDQUFDO0FBQzFCLE1BQU0sU0FBUyxHQUFHLFNBQVMsQ0FBQztBQUM1QixNQUFNLFFBQVEsR0FBRyxTQUFTLENBQUM7QUFDM0IsTUFBTSxVQUFVLEdBQUcsU0FBUyxDQUFDO0FBRTdCLE1BQU0sV0FBVyxHQUFHO0lBQ2xCLFdBQVcsRUFBRSxPQUFPO0lBQ3BCLE9BQU87SUFDUCxZQUFZLEVBQUUsSUFBQSxZQUFJLEVBQUMsT0FBTyxFQUFFLEdBQUcsQ0FBQztJQUNoQyxjQUFjLEVBQUUsSUFBQSxZQUFJLEVBQUMsT0FBTyxFQUFFLElBQUksQ0FBQztJQUNuQyxTQUFTO0lBQ1QsY0FBYyxFQUFFLElBQUEsWUFBSSxFQUFDLFNBQVMsRUFBRSxHQUFHLENBQUM7SUFDcEMsZ0JBQWdCLEVBQUUsSUFBQSxZQUFJLEVBQUMsU0FBUyxFQUFFLElBQUksQ0FBQztJQUN2QyxRQUFRO0lBQ1IsYUFBYSxFQUFFLElBQUEsWUFBSSxFQUFDLFFBQVEsRUFBRSxHQUFHLENBQUM7SUFDbEMsZUFBZSxFQUFFLElBQUEsWUFBSSxFQUFDLFFBQVEsRUFBRSxJQUFJLENBQUM7SUFDckMsSUFBSSxFQUFFLFNBQVM7SUFDZixVQUFVO0lBQ1YsUUFBUSxFQUFFLFNBQVM7SUFDbkIsSUFBSSxFQUFFLFNBQVM7SUFDZixTQUFTLEVBQUUsU0FBUztJQUNwQixXQUFXLEVBQUUsU0FBUztJQUN0QixXQUFXLEVBQUUsU0FBUztJQUN0QixPQUFPLEVBQUUsU0FBUztJQUNsQixPQUFPLEVBQUUsU0FBUztJQUNsQixLQUFLLEVBQUUsU0FBUztDQUNqQixDQUFDO0FBRUYsa0JBQWUsV0FBVyxDQUFDIn0=